var monitor = {
    svgns: "http://www.w3.org/2000/svg",
    svgDocument: {},
    pointsGroup: {},
    socket: {},
    removePoints: true,
    delay: 500,
    animationTime: 2000,
    init: function (locationID) {
        this.socket = io("http://services-dev.synchront.net/"+locationID);
        this.svgDocument = document.getElementById('heatmap_svg_element');
        this.pointsGroup = document.getElementById('points');
        this.player.playPause = document.getElementById('play_pause');
        this.addSocketEvents();
        this.setTimer();
    },
    createCircle: function (cx,cy) {
        var circle = document.createElementNS(monitor.svgns, "circle"),
            timestamp = new Date().getTime();

        circle.setAttributeNS(null, 'cx', cx);
        circle.setAttributeNS(null, 'cy', cy);
        circle.setAttributeNS(null, 'r', '7.5');
        circle.setAttributeNS(null, 'fill', '#ee036a');
        if(this.removePoints){
            circle.setAttributeNS(null, 'class', 'circles animate');
        }else{
            circle.setAttributeNS(null, 'class', 'circles');
        }

        circle.setAttributeNS(null, 'data-time', timestamp);
        circle.setAttributeNS(null, 'id', timestamp);
        this.setDelayAndAnimationTime(circle);

        monitor.pointsGroup.appendChild(circle);
        if(this.removePoints){
            setTimeout(function () {
                circle.parentNode.removeChild(circle);
            }, this.delay+this.animationTime);
        }
    },
    player: {
        isPlaying: true,
        playPause: {},
        toggle: function () {
            if($(this.playPause).attr('data-play') == 1){
                this.playPause.setAttributeNS(null, 'fill', 'url(#play)');
                $(this.playPause).attr('data-play',0);
                this.isPlaying = false;
            }else{
                this.playPause.setAttributeNS(null, 'fill', 'url(#pause)');
                $(this.playPause).attr('data-play',1);
                this.isPlaying = true;
            }
        }
    },
    convertXY: function (x,y) {
        return {'x':x/13.2+170,'y':800-(y/14-480)};
    },
    addSocketEvents: function () {
        this.socket.on('points', function(points){
            if(monitor.player.isPlaying){
                var pointsArr = JSON.parse(points);
                for(var i = 0; i < pointsArr.length;i++){
                    // var coords = monitor.convertXY(pointsArr[i][0],pointsArr[i][1]);
                    // monitor.createCircle(coords.x,coords.y);
                    monitor.createCircle(pointsArr[i][0],pointsArr[i][1]);
                }
            }
        });

        this.socket.emit('getWeather', '');
        this.socket.on('weather', function(weather){
            console.log('weather: ', weather);
            if(weather != 'n/a'){
                $("#daily_weather #city").html(weather[1]);
                $("#daily_weather #temperature").html(weather[0]);
                $("#daily_weather #temp_str").html(weather[2]);
                $("#weather_img image").attr('xlink:href','/assets/img/icons/weather/'+weather[4]+'.png');
                $("#daily_weather #weather_date").html(weather[3]);
            }
        });

        this.socket.on('status', function(status){
            console.log('status: '+status);
            $("#status").html(status == '1'?'Live':'Offline');
        });

        this.socket.on('disconnect', function() {
            console.log('Got disconnect!');
            $("#status").html('Offline');
        });

        this.socket.on('connect', function() {
            console.log('Connected!');
            $("#status").html('Live');
        });
    },
    setTimer: function () {
        setInterval(function () {
            $("#weather_time").html(utils.getTimeWithAMPM(true));
        },1000);
    },
    removePointsToggle: function () {
        var obj = $("#remove_points"),
            rp = document.getElementById('remove_points'),
            pipe = document.getElementById('remove_points_pipe'),
            points = $(".circles");
        if(obj.attr('data-checked') == 1){
            pipe.setAttribute('opacity', 0);
            obj.attr('data-checked', 0);
            points.remove();
            this.removePoints = false;
        }else{
            pipe.setAttribute('opacity', 1);
            obj.attr('data-checked', 1);
            points.addClass('animate');
            this.removePoints = true;
        }
    },
    setDelayAndAnimationTime: function (point) {
        var points = typeof point != 'undefined'?$(point):$(".circles");
        this.delay = parseInt($("#delay").val());
        this.animationTime = parseInt($("#animationTime").val());
        // console.log('delay: '+this.delay,'animationTime: '+this.animationTime);
        if(this.removePoints) {
            points.css({
                'animation': (this.animationTime / 1000) + 's ease ' + (this.delay / 1000) + 's normal forwards 1 fadeOut',
                '-webkit-animation': (this.animationTime / 1000) + 's ease ' + (this.delay / 1000) + 's normal forwards 1 fadeOut',
            });
        }
        if(typeof point == 'undefined'){
            $.post('/cat/cat/setDelayAndAnimationTime', {delay:monitor.delay, animationTime: monitor.animationTime});
        }
    },
    hoverSensor: function (sensorID) {
        var sensor = document.getElementById("sensor_"+sensorID);
        console.log(sensor);
        if($(sensor).attr('data-hover') == 0){
            sensor.setAttribute('fill', 'url(#sensor_hover)');
            $(sensor).attr('data-hover', 1);
            $(sensor).parent().parent().find('.sensor_layer').attr('opacity','.1');
        }else{
            sensor.setAttribute('fill', 'url(#sensor)');
            $(sensor).attr('data-hover', 0);
            $(sensor).parent().parent().find('.sensor_layer').attr('opacity','0');
        }
    }
};